import React from 'react';

export default function Pill({ label, color, active, onClick }) {
  return (
    <button onClick={onClick} className={`pill ${active ? 'pillActive' : ''}`} style={{ '--pill': color }} aria-pressed={active} title={label}>
      <span className="pillDot" />
      <span className="pillTxt">{label}</span>
    </button>
  );
}
